// extracted by mini-css-extract-plugin
module.exports = {"bigEnergyTotal":"inddex_bigEnergyTotal__3nbEz"};